// extracted by mini-css-extract-plugin
export default {"GraphDetail":"styles_GraphDetail__lqU0p","label":"styles_label__dLsQY","name":"styles_name__zOUtC","amount":"styles_amount__FKBgy","reference":"styles_reference__vhReQ"};